module.exports = __webpack_public_path__ + "img/logo.d7e31c5d.png";